import ACTIONS from 'application/constants'

export const setConsentAccept = (dateAccept) => ({
    type: ACTIONS.CONSENT_SET_ACCEPT,
    dateAccept
})